import KformComponent from '../kform-component';

export default class RepreComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentRepre | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.add = settings?.add ?? true;
		this.defaultValue = settings?.defaultValue;
		this.disabled = settings?.disabled ?? false;
		this.insert = settings?.insert ?? true;
		this.kdata = {
			submit: false,
			...settings?.kdata,
		};
		this.forceView = settings?.forceView ?? '';
		this.validate = {
			custom:        settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
			rules:         settings?.validate?.rules,
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'kid',
			'lang',
			'type',
			'value',
		]);
	}
}
